import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";
import { RDDV2FormDocumentModel, RDDV2DocumentDTO } from "../Common/RDDV2FormDocumentModel";
import { RDDV2FormFileModel, RDDV2FileDTO } from "../Common/RDDV2FormFileModel";

export class RDDV2FormModel extends ModelBase<RDDV2FormModel> {
    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_PROJECT_ID = "";
    public static readonly DEFAULT_RDDV2CATEGORY_ID = "";
    public static readonly DEFAULT_CATEGORY_NAME = "";
    public static readonly DEFAULT_SUPPLIER_REFERENCE = "";
    public static readonly DEFAULT_CLIENT_REFERENCE = null;
    public static readonly DEFAULT_SUPPLIER_ID = "";
    public static readonly DEFAULT_RDDV2_STATUS_ID = "";
    public static readonly DEFAULT_PARENT_RDDV2_ID = null;
    public static readonly DEFAULT_REQUESTED_BY_USER_ID = null;
    public static readonly DEFAULT_REQUESTED_DATE = null;
    public static readonly DEFAULT_TITLE = "";
    public static readonly DEFAULT_DESCRIPTION = "";
    public static readonly DEFAULT_REQUESTEDTO = "";
    public static readonly DEFAULT_RESPONSE_REQUIRED_BY_DATE = null;
    public static readonly DEFAULT_LAST_UPDATED_DATE = null;
    public static readonly DEFAULT_CREATED_DATE = null;
    public static readonly DEFAULT_CREATED_BY_USER_ID = null;
    public static readonly DEFAULT_LAST_UPDATED_BY_USER_ID = null;
    public static readonly DEFAULT_IS_DELETED = false;
    public static readonly DEFAULT_ROW_VERSION = null;
    public static readonly DEFAULT_RDDV2_ATTACHMENTS = [];
    public static readonly DEFAULT_REVISION = null;
    public static readonly DEFAULT_RDDV2_DOCUMENTS = [];
    public static readonly DEFAULT_UNIQUE_ID = "";
    public static readonly DEFAULT_ISFROMDARWIN = false;

    @observable
    public id: string | null = RDDV2FormModel.DEFAULT_ID;
    @observable
    public projectId: string = RDDV2FormModel.DEFAULT_PROJECT_ID;
    @observable
    public rddV2CategoryId: string = RDDV2FormModel.DEFAULT_RDDV2CATEGORY_ID;
    @observable
    public categoryName: string = RDDV2FormModel.DEFAULT_CATEGORY_NAME;
    @observable
    public supplierReference: string | null = RDDV2FormModel.DEFAULT_SUPPLIER_REFERENCE;
    @observable
    public clientReference: number | null = RDDV2FormModel.DEFAULT_CLIENT_REFERENCE;
    @observable
    public supplierId: string | null = RDDV2FormModel.DEFAULT_SUPPLIER_ID;
    @observable
    public rddV2StatusId: string | null = RDDV2FormModel.DEFAULT_RDDV2_STATUS_ID;
    @observable
    public parentRDDV2Id: string | null = RDDV2FormModel.DEFAULT_PARENT_RDDV2_ID;
    @observable
    public requestedByUserId: string | null = RDDV2FormModel.DEFAULT_REQUESTED_BY_USER_ID;
    @observable
    public requestedDate: string | null = RDDV2FormModel.DEFAULT_REQUESTED_DATE;
    @observable
    public title: string | null = RDDV2FormModel.DEFAULT_TITLE;
    @observable
    public description: string | null = RDDV2FormModel.DEFAULT_DESCRIPTION;
    @observable
    public requestedTo: string | null = RDDV2FormModel.DEFAULT_REQUESTEDTO;
    @observable
    public responseRequiredByDate: string | null = RDDV2FormModel.DEFAULT_RESPONSE_REQUIRED_BY_DATE;
    @observable
    public createdDate: string | null = RDDV2FormModel.DEFAULT_CREATED_DATE;
    @observable
    public createdByUserId: string | null = RDDV2FormModel.DEFAULT_CREATED_BY_USER_ID;
    @observable
    public lastUpdatedDate: string | null = RDDV2FormModel.DEFAULT_LAST_UPDATED_DATE;
    @observable
    public lastUpdatedByUserId: string | null = RDDV2FormModel.DEFAULT_LAST_UPDATED_BY_USER_ID;
    @observable
    public isDeleted: boolean = RDDV2FormModel.DEFAULT_IS_DELETED;
    @observable
    public rowVersion: string | null = RDDV2FormModel.DEFAULT_ROW_VERSION;
    @observable
    public rddV2Attachments: RDDV2FormFileModel[] = RDDV2FormModel.DEFAULT_RDDV2_ATTACHMENTS;
    @observable
    public revision: number | null = RDDV2FormModel.DEFAULT_REVISION;
    @observable
    public rddV2Documents: RDDV2FormDocumentModel[] = RDDV2FormModel.DEFAULT_RDDV2_DOCUMENTS;
    @observable
    public uniqueId: string | null = RDDV2FormModel.DEFAULT_UNIQUE_ID;
    @observable
    public isFromDarwin: boolean = RDDV2FormModel.DEFAULT_ISFROMDARWIN;

    @action
    public reset = () => {
        this.id = RDDV2FormModel.DEFAULT_ID;
        this.projectId = RDDV2FormModel.DEFAULT_PROJECT_ID;
        this.rddV2CategoryId = RDDV2FormModel.DEFAULT_RDDV2CATEGORY_ID;
        this.categoryName = RDDV2FormModel.DEFAULT_CATEGORY_NAME;
        this.supplierReference = RDDV2FormModel.DEFAULT_SUPPLIER_REFERENCE;
        this.clientReference = RDDV2FormModel.DEFAULT_CLIENT_REFERENCE;
        this.supplierId = RDDV2FormModel.DEFAULT_SUPPLIER_ID;
        this.rddV2StatusId = RDDV2FormModel.DEFAULT_RDDV2_STATUS_ID;
        this.parentRDDV2Id = RDDV2FormModel.DEFAULT_PARENT_RDDV2_ID;
        this.requestedByUserId = RDDV2FormModel.DEFAULT_REQUESTED_BY_USER_ID;
        this.requestedDate = RDDV2FormModel.DEFAULT_REQUESTED_DATE;
        this.title = RDDV2FormModel.DEFAULT_TITLE;
        this.description = RDDV2FormModel.DEFAULT_DESCRIPTION;
        this.requestedTo = RDDV2FormModel.DEFAULT_REQUESTEDTO;
        this.responseRequiredByDate = RDDV2FormModel.DEFAULT_RESPONSE_REQUIRED_BY_DATE;
        this.createdDate = RDDV2FormModel.DEFAULT_CREATED_DATE;
        this.createdByUserId = RDDV2FormModel.DEFAULT_CREATED_BY_USER_ID;
        this.lastUpdatedDate = RDDV2FormModel.DEFAULT_LAST_UPDATED_DATE;
        this.lastUpdatedByUserId = RDDV2FormModel.DEFAULT_LAST_UPDATED_BY_USER_ID;
        this.isDeleted = RDDV2FormModel.DEFAULT_IS_DELETED;
        this.rowVersion = RDDV2FormModel.DEFAULT_ROW_VERSION;
        this.rddV2Attachments.length = 0;
        this.revision = RDDV2FormModel.DEFAULT_REVISION;
        this.rddV2Documents.length = 0;
        this.uniqueId = RDDV2FormModel.DEFAULT_UNIQUE_ID;
        this.isFromDarwin = RDDV2FormModel.DEFAULT_ISFROMDARWIN;
    };

    @action
    public fromDto(dto: RDDV2AndRelatedResponseDTO): void {
        const rddV2Dto = dto.rddV2;

        for (let key in rddV2Dto) {
            if (rddV2Dto.hasOwnProperty(key)) {
                if (key === "rddV2Attachments") {
                    // do nothing
                } else if (this[key] instanceof Date) {
                    this[key] = new Date(rddV2Dto[key]);
                } else {
                    this[key] = rddV2Dto[key];
                }
            }
        }

        let processedFiles: RDDV2FormFileModel[] = [];

        for (const item of dto.rddV2Attachments) {
            const itemToAdd = new RDDV2FormFileModel();
            itemToAdd.fromDto(item);
            processedFiles.push(itemToAdd);
        }

        this.rddV2Attachments = [...this.rddV2Attachments, ...processedFiles];

        let processedDocuments: RDDV2FormDocumentModel[] = [];

        for (const rddV2Document of dto.rddV2Documents) {
            const rddV2DocumentToAdd = new RDDV2FormDocumentModel();
            rddV2DocumentToAdd.fromDto(rddV2Document);
            processedDocuments.push(rddV2DocumentToAdd);
        }

        this.rddV2Documents = [...this.rddV2Documents, ...processedDocuments];
    }

    public toDto() {
        const rddV2FormModel: RDDV2DTO = {
            id: this.id,
            projectId: this.projectId,
            rddV2CategoryId: this.rddV2CategoryId,
            categoryName: this.categoryName,
            supplierReference: this.supplierReference,
            clientReference: this.clientReference,
            supplierId: this.supplierId,
            rddV2StatusId: this.rddV2StatusId,
            parentRDDV2Id: this.parentRDDV2Id,
            requestedByUserId: this.requestedByUserId,
            requestedDate: this.requestedDate,
            title: this.title,
            description: this.description,
            requestedTo: this.requestedTo,
            responseRequiredByDate: this.responseRequiredByDate,
            createdDate: this.createdDate,
            createdByUserId: this.createdByUserId,
            lastUpdatedDate: this.lastUpdatedDate,
            lastUpdatedByUserId: this.lastUpdatedByUserId,
            isDeleted: this.isDeleted,
            rowVersion: this.rowVersion,
            revision: this.revision,
            uniqueId: this.uniqueId,
            isFromDarwin: this.isFromDarwin,
        };

        return rddV2FormModel;
    }

    @action
    public fromRelatedDto(dto: RDDV2RelatedResultResponseDTO): void {}
}

export interface RDDV2StatusDTO {
    id: string;
    displayName: string;
}

export interface RDDV2SupplierDTO {
    id: string;
    displayName: string;
}

export interface RDDV2CategoryDTO {
    id: string;
    displayName: string;
}

export interface RDDV2RequestedByDTO {
    id: string;
    displayName: string;
}

export interface RDDV2DarwinSupplierReferenceDTO {
    id: string;
    displayName: string;
}

export interface RDDV2DTO {
    id: string | null;
    projectId: string;
    rddV2CategoryId: string;
    categoryName: string;
    supplierReference: string | null;
    clientReference: number | null;
    supplierId: string | null;
    rddV2StatusId: string | null;
    parentRDDV2Id: string | null;
    requestedByUserId: string | null;
    requestedDate: string | null;
    title: string | null;
    description: string | null;
    requestedTo: string | null;
    responseRequiredByDate: string | null;
    createdDate: string | null;
    createdByUserId: string | null;
    lastUpdatedDate: string | null;
    lastUpdatedByUserId: string | null;
    isDeleted: boolean;
    rowVersion: string | null;
    revision: number | null;
    uniqueId: string | null;
    isFromDarwin: boolean;
}

export interface UpsertRDDV2AndRelatedRequestDTO {
    rddV2: RDDV2DTO;
    rddV2Attachments: RDDV2FileDTO[];
    rddV2Documents: RDDV2DocumentDTO[];
}

export interface RDDV2AndRelatedResponseDTO extends RDDV2RelatedResultResponseDTO {
    rddV2: RDDV2DTO;
    rddV2Attachments: RDDV2FileDTO[];
    rddV2Documents: RDDV2DocumentDTO[];
}

export interface RDDV2ProjectDetailsDTO {
    projectReference: string;
    projectName: string;
}

export interface RDDV2RelatedResultResponseDTO {
    suppliers: RDDV2SupplierDTO[];
    statuses: RDDV2StatusDTO[];
    rddV2ProjectDetails: RDDV2ProjectDetailsDTO;
    categories: RDDV2CategoryDTO[];
}

export interface RDDV2Attachment {
    rddV2Id: string | null;
    fileName: string;
    fileURL: string;
    createdByUserId: string | null;
    isDeleted: boolean;
}

export interface RDDV2CategoryDocument {
    rddV2CategoryId: string | null;
    fileName: string;
    fileURL: string;
    createdByUserId: string | null;
    isDeleted: boolean;
}
